import gsap from 'gsap';
import { Swiper } from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

export default class{

    /**
     * constructor
     */
    constructor(){
        this.slider = document.querySelectorAll('[data-main-index-visual-slider]');
    }

    /**
     * init
     */
    init(){
        this.slider.forEach(slider => {
            const pagination = slider.querySelector('[data-main-index-visual-pagination]');
            const realSlideCount = parseInt(slider.dataset.slideCount, 10);

            new Swiper(slider, {
                modules: [Pagination, Autoplay],
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: true,
                speed: 1000,
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 50
                    }
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                    type: 'custom',
                    renderCustom: function (swiper, current, total){
                        let dots = '';
                        for (let i = 0; i < realSlideCount; i++) {
                            dots += `<span class="swiper-pagination-bullet${swiper.realIndex % realSlideCount === i ? ' swiper-pagination-bullet-active' : ''}"></span>`;
                        }
                        return dots;
                    }
                },
            });
        });
    }

}